<template>
  <!-- 开票信息详情 -->
  <detailsCommon :boxList="boxList" :form="info"></detailsCommon>
</template>
<script>
import { operationDetail } from "@/api/request";
import detailsCommon from "./formPop/detailsCommon";
export default {
  components: { detailsCommon},
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    return {
      boxList: [
        {
          isDesc: true,
          descTitle: "发票抬头",
          formItem: [
            { label: "发票抬头:", prop: "invoiceTitle", span: 12 },
            { label: "企业税号:", prop: "enterpriseTaxNumber", span: 12 },
            { label: "开户行名称:", prop: "openBankName", span: 12 },
            { label: "开户行账户:", prop: "openBankAccount", span: 12 },
            { label: "注册地址:", prop: "registeredAddress", span: 12 },
            { label: "注册电话:", prop: "registeredTelephone", span: 12 },
          ]
        },
        {
          isDesc: true,
          descTitle: "收件信息",
          formItem: [
            { label: "收件人姓名:", prop: "addressee", span: 12 },
            { label: "收件地址:", prop: "deliveryAddress", span: 12 },
            { label: "收件邮箱:", prop: "receivingContact", span: 12 },
            { label: "收件联系方式:", prop: "receivingContactInformation", span: 12 }
          ]
        }
      ],
    };
  },
  methods: {
  }
};
</script>